document.addEventListener('DOMContentLoaded', function() {
  // Make sure Swiper exists
  if (typeof Swiper === 'undefined') return;

  // Select main Swiper container and thumbnails
  const mainSwiperEl = document.querySelector('.theme-viewport.swiper-container');
  const thumbs = document.querySelectorAll('.product-area__thumbs__thumb a');

  // Ensure elements exist
  if (!mainSwiperEl || thumbs.length === 0) return;

  // Initialize main Swiper if not already initialized
  const mainSwiper = mainSwiperEl.swiper || new Swiper(mainSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    allowTouchMove: true,
    on: {
      init: function() {
        // Highlight first thumbnail on load
        if (thumbs[0]) thumbs[0].classList.add('thumb-active');
      }
    }
  });

  // Move thumbnails below slider
  $('.product-area__thumbs').appendTo('.product-slider');

  // Attach click handler for thumbnails
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();     // Prevent default anchor behavior
      e.stopPropagation();    // Stop any other click listeners

      // Slide Swiper to clicked thumbnail
      mainSwiper.slideTo(index);

      // Update active thumbnail
      thumbs.forEach(t => t.classList.remove('thumb-active'));
      thumb.classList.add('thumb-active');
    });
  });
});

// Function to replace account link text with SVG
function replaceAccountText() {
  var $link = $('a.nav-account');
  if ($link.length) {
    var userIconSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
     viewBox="0 0 24 24" stroke="black" stroke-width="1"
     stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="8" r="4" fill="none"></circle>
  <path d="M4 20c0-4 4-6 8-6s8 2 8 6" fill="none"></path>
</svg>
`;
    $link.html(userIconSVG);
    return true; // done
  }
  return false; // not found yet
}

// Check every 100ms until the element exists, then replace it
var interval = setInterval(function() {
  if (replaceAccountText()) {
    clearInterval(interval);
  }
}, 100);

(function () {

  function removeSoldOutProducts(root = document) {
    var soldOut = root.querySelectorAll('.product-block.sold-out');
    soldOut.forEach(function (el) {
      el.remove();
    });
  }

  // Run once on initial load
  document.addEventListener('DOMContentLoaded', function () {
    removeSoldOutProducts();

    // Observe future DOM changes (lazy load / infinite scroll)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          // If the added node IS a sold-out product
          if (node.matches && node.matches('.product-block.sold-out')) {
            node.remove();
          }

          // Or contains sold-out products inside it
          removeSoldOutProducts(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();
